import React, { useState } from 'react'
import './styles.scss'

export const TABox = ({
  title,
  caption
}: {
  title: React.ReactChild
  caption: React.ReactChild
}) => {
  return (
    <div className='TABox'>
      <Accordeon
        head={
          <>
            <div className='title'>{title}</div>
          </>
        }
        content={
          <>
            <div className='caption'>{caption}</div>
          </>
        }
      />
    </div>
  )
}

const Accordeon = ({
  head,
  content
}: {
  head: React.ReactChild
  content: React.ReactChild
}) => {
  const [open, setOpen] = useState(false)
  return (
    <div className={'accordeon ' + (open ? 'open' : '')}>
      <div className='head' onClick={() => setOpen(!open)}>
        {head}{' '}
        <div className={'action'}>
          Infos {open ? 'ausblenden' : 'einblenden'}
        </div>
      </div>
      <div className='content'>{content}</div>
    </div>
  )
}
